import * as React from 'react';
import { CompressionDateOption } from 'components/common/compression-date-option';
import { InsightsCard } from 'components/common/insights-card';
import { InsightsDateOption, InsightsMessage } from 'src/common/models';

interface RegionCompressionCardProps {
  compression: InsightsMessage;
  dateOptions?: InsightsDateOption[];
}

export const RegionCompressionCard: React.FunctionComponent<RegionCompressionCardProps> = ({ compression, dateOptions }) => (
  <InsightsCard heading={compression.heading} subHeading={compression.subHeading}>
    {dateOptions &&
      dateOptions.map((option, index) => (
        <CompressionDateOption
          key={`dateOption-${index}`}
          dateRange={option.dateRange}
          index={index}
          link={option.searchLink}
          price={option.minPrice}
        />
      ))}
  </InsightsCard>
);
